<div class="p-8 flex flex-col gap-8 max-h-[90vh] overflow-y-auto">
  <div class="flex justify-end -mb-5">
    @if (isFinance()) {
      <button ui-kit-button variant="stroked" (click)="logout()">
        {{ 'common.logout' | transloco }}
      </button>
    } @else {
      <button dialogClose>
        <img src="/assets/images/icons/close-dialog.svg" alt="Close" />
      </button>
    }
  </div>

  @if (purchaseSuccess()) {
    <div class="flex flex-col items-center gap-4 text-center py-6">
      <h1 class="!text-2xl font-semibold">{{ 'membership.plans.success.title' | transloco }}</h1>
      <p class="text-center">
        {{
          (isAddonOnlyPurchase ? 'membership.plans.success.addons.description' : 'membership.plans.success.description')
            | transloco
        }}
      </p>
    </div>
  } @else {
    @if (!canManageSubscription()) {
      <div class="flex justify-center">
        <img
          ngSrc="/assets/images/brand/safehire-placeholder.png"
          class="w-40 h-40 object-cover mb-4"
          alt="Safehire"
          width="160"
          height="160"
          priority
        />
      </div>
    }

    <h1 class="!text-2xl font-semibold text-center">
      @if (isFinance()) {
        {{ 'membership.plans.finance.title' | transloco }}
      } @else if (canManageSubscription()) {
        {{ 'membership.plans.title' | transloco }}
      } @else {
        {{ 'membership.plans.readonly.title' | transloco }}
      }
    </h1>

    @if (canManageSubscription()) {
      <app-plan-addon-flow
        [products]="products"
        [cyberExposureProducts]="cyberExposureProducts"
        [aiAddonProducts]="aiAddonProducts"
        [mode]="flowMode()"
        (checkout)="createCheckout($event)"
      />
    } @else {
      <p class="text-center">{{ 'membership.plans.readonly.description' | transloco }}</p>
    }
  }
</div>
